import React from 'react';
import PropTypes from 'prop-types';

export default function ErrorToastMessage({ responseCode }) {
  const {
    onClick = () => window.location.reload(),
    msg = 'Something went wrong',
    btnTxt = 'Reload'
  } = responseCode === 404 ? {
    // let user go back; refreshing same page isnt helpful
    onClick: () => window.history.back(),
    msg: 'Not found',
    btnTxt: 'Go Back'
  } : {};

  return (
    <div className="ErrorToastMessage flex">
      <p className="flex-auto">{ msg }</p>
      <button
        type="button"
        className="button pv1 ph2 f2 fw5 ml3 mr1"
        onClick={ onClick }
      >
        { btnTxt }
      </button>
    </div>
  );
}

ErrorToastMessage.propTypes = {
  responseCode: PropTypes.number.isRequired
};

